

// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { CartProvider } from "./contexts/CartContext";
// import { AuthProvider, useAuth } from "./contexts/AuthContext";
// import { FavoritesProvider } from "./contexts/FavoritesContext";
// import { OrdersProvider } from "./contexts/OrdersContext"; // ✅ Import new provider
// import HomePage from "./pages/HomePage";
// import ProductPage from "./components/product/ProductPage";
// import WishlistPage from "./pages/WishlistPage";
// import Header from "./components/layout/Header";
// import Footer from "./components/layout/Footer";
// import { Toaster } from "sonner";
// import ScrollToTop from "./components/ScrollToTop";
// import useAutoLogout from "./hooks/useAutoLogout";
// import AboutPage from "./pages/AboutPage";
// import ContactPage from "./pages/ContactUsPage";
// import OrderHistoryPage from "./pages/OrderHistoryPage";
// import { AdminPage } from "./pages/Admin"; 

// // 1. Define the logic component here
// const AppLogic = () => {
//   const { user } = useAuth(); // Get the current user
//   useAutoLogout(user); // Call your hook with the user
//   return null; // This component doesn't render anything
// };

// const App = () => {
//   return (
//     <Router>
//       <AuthProvider>
//         <FavoritesProvider>
//           <CartProvider>
//             {/* ✅ Wrap everything inside OrdersProvider */}
//             <OrdersProvider>
//               <AppLogic /> {/* 2. Place the logic component here */}
//               <ScrollToTop />
//               <Toaster position="top-right" richColors />
//               <Header />
//               <main>
//                 <Routes>
//                   <Route path="/" element={<HomePage />} />
//                   <Route path="/wishlist" element={<WishlistPage />} />
//                   <Route path="/product/:id" element={<ProductPage />} />
//                   <Route path="/orders" element={<OrderHistoryPage />} />
//                   <Route path="/about" element={<AboutPage />} />
//                   <Route path="/contact" element={<ContactPage />} />
//                 </Routes>
//               </main>
//               <Footer />
//             </OrdersProvider>
//           </CartProvider>
//         </FavoritesProvider>
//       </AuthProvider>
//     </Router>
//   );
// };

// export default App;

import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";

// Contexts
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { FavoritesProvider } from "./contexts/FavoritesContext";
import { OrdersProvider } from "./contexts/OrdersContext";

// Shared Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import AnnouncementBar from "./components/common/AnnouncementBar";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "sonner";
import useAutoLogout from "./hooks/useAutoLogout";
import { trackPageView } from "./lib/analytics";

// Pages
import HomePage from "./pages/HomePage";
import ProductPage from "./components/product/ProductPage";
import WishlistPage from "./pages/WishlistPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactUsPage";
import OrderHistoryPage from "./pages/OrderHistoryPage";
import CollectionsPage from "./pages/CollectionsPage";
import CategoryPage from "./pages/CategoryPage";
import ShopPage from "./pages/ShopPage";
import ShippingInfoPage from "./pages/ShippingInfoPage";
import ReturnsPage from "./pages/ReturnsPage";
import SizingHelpPage from "./pages/SizingHelpPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";

// Auto logout logic
const AppLogic = () => {
  const { user } = useAuth();
  useAutoLogout(user);
  return null;
};

const RouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView({
      path: `${location.pathname}${location.search}`,
      title: document.title,
      location: window.location.href,
    });
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <FavoritesProvider>
          <CartProvider>
            <OrdersProvider>
              <AppLogic />
              <RouteAnalytics />
              <ScrollToTop />
              <Toaster position="top-right" richColors />

              <Routes>
                {/* ================================================
                    PUBLIC ROUTES
                ================================================ */}
                <Route
                  path="/*"
                  element={
                    <>
                      <AnnouncementBar />
                      <Header />
                      <main>
                        <Routes>
                          <Route path="/" element={<HomePage />} />
                          <Route path="/collections" element={<CollectionsPage />} />
                          <Route path="/shop" element={<ShopPage />} />
                          <Route path="/category/:slug" element={<CategoryPage />} />
                          <Route path="/wishlist" element={<WishlistPage />} />
                          <Route path="/product/:id" element={<ProductPage />} />
                          <Route path="/orders" element={<OrderHistoryPage />} />
                          <Route path="/about" element={<AboutPage />} />
                          <Route path="/contact" element={<ContactPage />} />
                          <Route path="/shipping-info" element={<ShippingInfoPage />} />
                          <Route path="/returns" element={<ReturnsPage />} />
                          <Route path="/sizing-help" element={<SizingHelpPage />} />
                          <Route path="/login" element={<LoginPage />} />
                          <Route path="/signup" element={<SignupPage />} />
                        </Routes>
                      </main>
                      <Footer />
                    </>
                  }
                />
              </Routes>
            </OrdersProvider>
          </CartProvider>
        </FavoritesProvider>
      </AuthProvider>
      <Analytics />
    </Router>
  );
};

export default App;
